import React from 'react';
import moment from 'moment';

import { eventFullPropTypeShape } from '../../../../proptypes';
import schemaResolver from '../../../../state/resolvers/schema/races';

import Meta from '../../../Meta';

/**
 * Event detail page meta presentational component.
 */
const EventDetailPageMeta = (event) => {
  const {
    canonical, excerpt, images, location, startDate, startDateFormatted, title, meta,
  } = event;
  const hero = images && (!images.hero || images.hero.title !== 'stub image' ? images.hero : undefined);

  const date = startDate ? moment(startDate).format('YYYY — ddd D MMM') : '';
  const tTitle = `${title} ${date} — Book Now at Let's Do This`;

  return (
    <Meta
      title={tTitle}
      useTitleTemplate={false}
      description={excerpt}
      facebookImage={hero && hero.facebook}
      twitterImage={hero && hero.twitter}
      twitterLabel1={'When'}
      twitterData1={startDateFormatted || 'TBC'}
      {...location &&
        location.address && {
          twitterLabel2: 'Where',
          twitterData2: location.address.join(', '),
        }}
      canonical={canonical}
      schemata={schemaResolver(event)}
      {...meta}
    />
  );
};

EventDetailPageMeta.propTypes = {
  /**
   * String canonical to the event page.
   */
  canonical: eventFullPropTypeShape.canonical, // eslint-disable-line react/require-default-props
  /**
   * String excerpt of event.
   */
  excerpt: eventFullPropTypeShape.excerpt,
  /**
   * Object of images associated with the event.
   */
  images: eventFullPropTypeShape.images,
  /**
   * Object of location data.
   */
  location: eventFullPropTypeShape.location,
  /**
   * ISO string of event start date.
   */
  startDateFormatted: eventFullPropTypeShape.startDateFormatted,
  /**
   * String title of the event.
   */
  title: eventFullPropTypeShape.title, // eslint-disable-line react/require-default-props
};

EventDetailPageMeta.defaultProps = {
  excerpt: undefined,
  images: undefined,
  location: undefined,
  startDateFormatted: undefined,
};

export default EventDetailPageMeta;



// WEBPACK FOOTER //
// ./app/src/components/EventDetailPage/components/EventDetailPageMeta/index.jsx